import * as angular from "angular";
import {IController} from "angular";
import {UnitsOfTimeType} from "../../types/units-of-time.type";


export class BringozTimeInputComponent implements IController {
  value: number;
  permissions: string;
  unitOfTimeType: UnitsOfTimeType;
  ngPlaceholder: string;
  parentValue: number;
  onChange: Function;

  public unitsOfTimeType: typeof UnitsOfTimeType = UnitsOfTimeType;
  public valueToUnitOfTime: number;
  public parentValueToUnitOfTime: number;

  constructor() {
  }

  $onInit() {
    if (this.parentValue) {
      this.parentValueToUnitOfTime = this._convertValueToUnitOfTime(this.parentValue, this.unitOfTimeType);
    }
    this.valueToUnitOfTime = this._convertValueToUnitOfTime(this.value, this.unitOfTimeType);
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.value && !changes.value.isFirstChange()) {
      this.valueToUnitOfTime = this._convertValueToUnitOfTime(this.value, this.unitOfTimeType);
    }
  }

  onChangeValue(value, unitOfTime) {
    this.onChange({value: this._convertToMilliSeconds(value, unitOfTime)})
  }

  private _convertToMilliSeconds(value, unitOfTime) {
    if (!!value && unitOfTime === this.unitsOfTimeType.Minute) {
      return value * 60000;
    }
    return value;
  }

  private _convertValueToUnitOfTime(value, unitOfTime) {
    if (!!value && unitOfTime === this.unitsOfTimeType.Minute) {
      return value / 60000;
    }
    return value;
  }

}

angular
  .module('bringoz.admin.commons')
  .component('bringozTimeInput', {
    bindings: {
      value: '<',
      unitOfTimeType: '<',
      ngPlaceholder: '<',
      permissions: '<?',
      parentValue: '<?',
      onChange: '&'
    },
    template: require('./bringoz-time-input.html').default,
    controller: BringozTimeInputComponent
  });
